import Api from "../../utils/axios";

const MenuApi = {
  getAllCountry: () => Api.get(`master/get-all-country`),
  getAllCity: (id) => Api.get(`master/get-all-city/${id}`),

  // New method to get city coordinates based on city name
  getCityCoordinates: (cityName) => {
    const API_KEY = "e2d2bf279ed24d45badca10c6ec96ddb"; // Replace with your OpenCage API Key
    const BASE_URL = `https://api.opencagedata.com/geocode/v1/json`;
    return Api.get(BASE_URL, {
      params: {
        q: cityName,
        key: API_KEY,
        limit: 1, // Optional: limits results to the most relevant one
      },
    });
  },
  // all country info apis ---------------
  // get all country info
  getAllCountryInfo: () => Api.get("admin/get-all-country-info"),

  // method for creating country info
  createCountryInfo: (payload) =>
    Api.post("admin/create-country-info", payload),

  // method for updating country info by id
  updateCountryInfo: (countryId, payload) =>
    Api.put(`admin/update-country-info/${countryId}`, payload),

  // method for get country Info by Id
  getCountryInfoById: (countryId) =>
    Api.get(`admin/get-country-info-by-id/${countryId}`),

  // method for deleting countryInfo by Id
  deleteCountryInfoById: (countryId) =>
    Api.delete(`admin/delete-country-info/${countryId}`),

  // all city info api -----------------
  // get all city info
  getAllCityInfo: () => Api.get("admin/get-all-city-info"),

  // method for creating cityinfo
  createCityInfo: (payload) => Api.post("admin/create-city-info", payload),

  // method for updating city info by id
  updateCityInfo: (cityId, payload) =>
    Api.put(`admin/update-city-info/${cityId}`, payload),

  // method for get city Info by Id
  getCityInfoById: (cityId) => Api.get(`admin/get-city-info/${cityId}`),

  // method for deleting countryInfo by Id
  deleteCityInfo: (cityId) => Api.delete(`admin/delete-city-info/${cityId}`),

  // --------------------------------
  getAllBusinesgetsType: () => Api.get(`master/get-all-business-type`),
  getVenderCategory: (filter, search) => {
    // console.log("search", search);
    return Api.post(`product/get-all-category/?search=${search}`, filter);
  },
  // getAllSubCategory: (payload,search) => Api.post(`product/get-all-subcategory?search=${search}`,payload),

  item: {
    getAllFoodItemProduct: (payload, search = "") =>
      Api.post(`food-product/get-all-food-products?search=${search}`, payload),
    getAllItemProduct: (payload, search = "") =>
      Api.post(`product/get-all-products?search=${search}`, payload),
    getProductById: (id) => Api.get(`product/get-product-by-id/${id}`),
  },
  modifier: {
    getAllModifierCategory: (fitler) =>
      Api.post(`admin/get-all-modifier-category`, fitler),
  },
};

export default MenuApi;

export const CategoryApi = {
  getCategory: (payload, search = "") =>
    Api.post(`product/get-all-category?search=${search}`, payload),
  getApproveCategory: (type="Ecommerce") => type==="Ecommerce"?Api.get(`product/all-approved-category`):Api.get(`product/all-food-category`),
  getSingleCategory: (id) => Api.get(`product/get-all-category/${id}`),
  createCategory: (payload) =>
    Api.post(`product/create-category`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateCategory: (payload, id) =>
    Api.put(`product/update-category/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  deleteCategory: (id) => Api.delete(`product/delete-category/${id}`),
};

export const SubCategoryApi = {
  getSubCategory: (payload, search = "") =>
    Api.post(`product/get-all-subcategory?search=${search}`, payload),
  getSubSingleCategory: (id) => Api.get(`product/get-subcategory-by-id/${id}`),
  createSubCategory: (payload) =>
    Api.post("product/create-subcategory", payload,{
  headers: { "Content-Type": "multipart/form-data" },
}),
  updateSubCategory: (payload, id) =>
    Api.put(`product/update-subcategory/${id}`, payload,{
  headers: { "Content-Type": "multipart/form-data" },
}),
  deleteSubCategory: (id) => Api.delete(`product/delete-subcategory/${id}`),
};
